export default __webpack_public_path__ + "static/media/NewCarton.56a55efa.svg";